import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=45c10282&"
import script from "./Water.vue?vue&type=script&lang=js&"
export * from "./Water.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports